import __request__ from 'routing/request';
interface ReceiveTimes {
    readonly post_indexing: string;
    readonly post_processing: string;
    readonly ingest: string;
}
interface ProcessingStatusSummary {
    readonly receive_times: ReceiveTimes;
}
/**
 * Get processing status summary from node
 */
export function getStatus(): Promise<ProcessingStatusSummary> {
    return __request__('GET', '/system/processing/status', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get persisted processing status summary from node
 */
export function getPersistedStatus(): Promise<ProcessingStatusSummary> {
    return __request__('GET', '/system/processing/status/persisted', null, {}, {
        'Accept': ['application/json']
    });
}
